export const SITE_DATA_KEY = "siteData"
export const SUPPORTING_FILES_KEY = "files"

// Labels
export const POP_UP_TITLE_OVERVIEW = "Commissioning Process Overview"
export const POP_UP_SUBTITLE_OVERVIEW =
    "This pop-up gives an high-level overview of the ENA Connect Direct commissioning process"

export const POP_UP_TITLE_AMEND = "Amend Application Process Overview"
export const POP_UP_SUBTITLE_AMEND =
    "If your installation has changed vs the original application that was approved, you must submit an amendment prior to commissioning. The amendment form will be pre-populated with the original application data. Please review and update as necessary. The amendment will be reassessed and must be approved before commissioning can proceed."
